import React, { useState } from 'react';
import { getOrderColors, PRIORITY_COLORS, STATUS_COLORS } from '../utils/statusColors';
import ActionButton from './ActionButton';
import OrderDetail from './OrderDetail';

const OrderCard = ({ order, onUpdate }) => {
  const [isDetailOpen, setIsDetailOpen] = useState(false);
  
  const colors = getOrderColors(order);
  const priorityColors = PRIORITY_COLORS[order.priority] || PRIORITY_COLORS['Normal'];
  const statusColors = STATUS_COLORS[order.status] || STATUS_COLORS['Pending'];

  // Formatting the item summary line per Part 3 spec: "Shoe, Bag (+1 more)"
  const items = order.items || [];
  let itemSummary = 'No items';
  if (items.length > 0) {
    if (items.length <= 2) {
      itemSummary = items.map(i => i.item_type).join(', ');
    } else {
      itemSummary = `${items[0].item_type}, ${items[1].item_type} (+${items.length - 2} more)`;
    }
  }

  // Format Target Date for display
  const targetDateFormatted = new Date(order.target_date).toLocaleDateString('en-GB', {
    day: 'numeric', month: 'short', year: 'numeric'
  });

  return (
    <>
      <div
        onClick={() => setIsDetailOpen(true)}
        className={`bg-white rounded-lg shadow-sm border-l-4 ${colors.border} border-t border-r border-b border-gray-200 p-4 cursor-pointer hover:shadow-md transition-all relative`}
      >
        {/* Top Header Row */}
        <div className="flex justify-between items-start mb-2">
          <div className="flex items-center space-x-2">
            <span className="font-bold text-gray-900 text-lg">#{order.order_id}</span>
            {order.priority === 'Urgent' && (
              <span className={`text-xs px-2 py-0.5 rounded-full font-bold ${priorityColors.bg} ${priorityColors.text}`}>
                🔴 URGENT
              </span>
            )}
          </div>
          <span className={`text-xs px-2.5 py-1 rounded-md font-bold ${statusColors.bg} ${statusColors.text} border ${statusColors.border}`}>
            {order.status}
          </span>
        </div>

        {/* Customer Info */}
        <div className="text-sm text-gray-700 mb-1">
          <span className="font-medium text-gray-900">{order.customer_name}</span> • {order.phone_number}
        </div>

        {/* Items & Date Summary */}
        <div className="text-sm text-gray-600 mb-2">
          <span className="font-medium">{itemSummary}</span> • Target: <span className={`font-semibold ${colors.text}`}>{targetDateFormatted}</span>
        </div>

        {/* Issue Description (Truncated) */}
        {items.length > 0 && (
          <div className="text-sm text-gray-500 italic mb-4 truncate">
            "{items[0].issue_description}"
          </div>
        )}

        {/* Action Button Container - stops propagation so clicking button doesn't open modal */}
        <div className="flex justify-end border-t border-gray-100 pt-3" onClick={(e) => e.stopPropagation()}>
          <ActionButton order={order} onUpdate={onUpdate} />
        </div>
      </div>

      {isDetailOpen && (
        <OrderDetail 
          order={order} 
          onClose={() => setIsDetailOpen(false)} 
          onUpdate={onUpdate} 
        />
      )}
    </>
  );
};

export default OrderCard;